export enum ProductTypes {
  VARIANT = "variant_id",
  PRODUCT = "product_id",
  BUNDLE = "bundle_id",
}
